export enum ScheduleTypeEnum {
    Update = 1,
    Config = 2,
    Logs = 3,
    // LogAnalysis = 4,
    CaosConfigurationBackup = 5,
}

export function ScheduleTypeEnumToI18n(val: ScheduleTypeEnum) {
    switch (val) {
        case ScheduleTypeEnum.Update:
            return "scheduleConfiguration.updateSettings";
        case ScheduleTypeEnum.Config:
            return "scheduleConfiguration.securitySettings";
        case ScheduleTypeEnum.Logs:
            return "scheduleConfiguration.logDownload";
        // case ScheduleTypeEnum.LogAnalysis:
        //     return "scheduleConfiguration.logAnalysis";
        case ScheduleTypeEnum.CaosConfigurationBackup:
            return "scheduleConfiguration.caosConfigurationBackup";
        default:
            return "";
    }
}
